namespace GeniuzPOS.Product {
    export interface CsArticleSeasonForm {
        ArticleSeasonCode: Serenity.StringEditor;
        ArticleSeasonName: Serenity.StringEditor;
    }

    export class CsArticleSeasonForm extends Serenity.PrefixedContext {
        static formKey = 'Product.CsArticleSeason';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CsArticleSeasonForm.init)  {
                CsArticleSeasonForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(CsArticleSeasonForm, [
                    'ArticleSeasonCode', w0,
                    'ArticleSeasonName', w0
                ]);
            }
        }
    }
}
